<template>
    <div class="widget">
        <div class="widget-header clearfix" v-if="title">
            <h3><i v-if="icon" :class="icon"></i> <span>{{ title }}</span></h3>
        </div>

        <div class="widget-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Panel',
    props: {
        title: String,
        icon: String
    }
}
</script>

<style scoped lang="scss">
.widget {
    box-shadow: 2px 2px 2px #CCC;
}
</style>
